(function($) {
$(function(){

  var template_url = $('#template_url').val();

  if ($('.js-load-more').length) {
    $('.js-load-more').on('click', function(e){
      e.preventDefault();

      // Alias the button element
      var self = $(this);

      // Get the JSON data from thr button itself
      var data_json = (self.attr('data-data')) ? self.attr('data-data') : '';
      var load_data = JSON.parse(data_json);

      // Add the post count to the JSON array we got amove
      var post_count = $('' + load_data.single_class).length;
      load_data.post_count = post_count;

      // Change the button text to the loading text
      self.addClass('loading');
      self.find('span').html(load_data.loading_text);

      $.ajax({
        method: "GET",
        url: template_url + "/load-more.php",
        data: load_data,
        complete: function(){
          // console.log(this.url);
        }
      }).done(function(msg) {
        // console.log(msg);
        setTimeout(function(){
          $('' + load_data.container_class).append(msg);
          self.find('span').html(load_data.initial_text);
          self.removeClass('loading');
          if (load_data.total_posts == $('' + load_data.container_class + ' ' + load_data.single_class).length) {
            $('.js-load-more').remove();
          }
        }, 500);
      });

    });
  }//if ($('.js-load-more').length)


  if ($('.js-faux-load-more').length) {
    $('.js-faux-load-more').on('click', function(e){
      e.preventDefault();
      var load_num = parseInt($(this).attr('data-load-photos'));
      var total = parseInt($(this).attr('data-load-photos-total'));
      var selector = $(this).attr('data-load-photos-selector');
      $(selector + ':hidden').slice(0, load_num).fadeIn(300);

      if ($(selector + ':visible').length == total) {
        $('.js-faux-load-more').remove();
      }
    });
  }//if ($('.js-faux-load-more').length)

});
})(jQuery);
